var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#FF0064",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#00FFC2",
    points: "15.99249 27.00752 10.99249 22.00752 5.99249 27.00752 10.99249 32.00752"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#00FFC2",
    points: "26.00752 27.00752 21.00752 22.00752 16.00752 27.00752 21.00752 32.00752"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#00FFC2",
    points: "15.99249 16.99248 10.99249 11.99248 5.99249 16.99248 10.99249 21.99248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#00FFC2",
    points: "26.00752 16.99248 21.00752 11.99248 16.00752 16.99248 21.00752 21.99248"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09);
export default __webpack_public_path__ + "static/media/09.62d6cbf7a924992324b3781140c7e352.svg";
export { ForwardRef as ReactComponent };